import React, { createContext, useState } from 'react';
import { notification } from "antd";
//import useWindowDimensions from '../hooks/useWindowDimensions';

const GlobalContext = createContext();

const GlobalContextProvider = ({ children }) => {
    //const { width, height} = useWindowDimensions();
    const [loading, setLoading] = useState(false)
    const [selectedMunicipality, setSelectedMunicipality] = useState()
    const [selectedAnalyticsMunicipality, setSelectedAnalyticsMunicipality] = useState()

    const successHandler = (message) => {
        notification.info({
            message: `Uspjeh`,
            description: message,
            //placement: width < 545 && 'topRight' || 'bottomRight',
            placement: 'bottomRight',
        });
    }

    const errorHandler = (message) => {
        notification.error({
            message: `Greška`,
            description: message,
            //placement: width < 545 && 'topLeft' || 'bottomRight',
            placement: 'bottomRight',
        });
    }

    return (
        <GlobalContext.Provider value={{
            successHandler,
            errorHandler,
            loading,
            setLoading,
            selectedMunicipality, 
            setSelectedMunicipality,
            selectedAnalyticsMunicipality,
            setSelectedAnalyticsMunicipality
        }}>
            {children}
        </GlobalContext.Provider>
    )
}

export { GlobalContextProvider, GlobalContext };